import { UserAction, UserListItemDto } from '../config/userConfig'
import { getAxiosFulfilledState, getPendingState, getRejectedState, resetState } from '../helpers/reducerHelper'
import { IReduxAction } from './index'
import { DataPromise, getDataEmptyState } from '../context/AxiosContext'
import { ActionType } from 'redux-promise-middleware'

export interface IUserState {
    list: DataPromise<UserListItemDto[]>
}

const defaultState: IUserState = {
    list: getDataEmptyState<UserListItemDto[]>(undefined, []),
}

export default function reducer(state: IUserState = defaultState, action: IReduxAction): IUserState {
    switch (action.type) {
        case `${UserAction.GetList}_${ActionType.Pending}`: {
            return getPendingState(state, 'list')
        }
        case `${UserAction.GetList}_${ActionType.Rejected}`: {
            return getRejectedState(state, action, 'list')
        }
        case `${UserAction.GetList}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'list')
        }
        case UserAction.ResetList: {
            return resetState(state, { list: [] })
        }
    }

    return state
}
